import { render, staticRenderFns } from "./GradingPlanCards.vue?vue&type=template&id=672c4c6d&"
import script from "./GradingPlanCards.vue?vue&type=script&lang=js&"
export * from "./GradingPlanCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports